import { React, useContext, useEffect } from "react";
import Meta from "./../components/Meta";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import DashboardSection from "./../components/DashboardSection";
import { requireAuth } from "./../util/auth";
import { useProductionsByOwner } from "../util/db";
import { getPendingSignup, deletePendingSignup, createProduction } from "../util/apiHelpers";
import { useAuth } from "./../util/auth";
import { SearchProvider } from "../providers/SearchProvider";
import { CategoryProvider } from "../providers/CategoryProvider";
import { useRouter } from "./../util/router";
import { createInitialLocationFromSignUpAddress } from "../util/createInitialLocationFromSignUpAddress";
import { GoogleMapsContext } from "../providers/GoogleMapsProvider";
import { DateContext } from "../providers/DateProvider";

function DashboardPage(props) {
  const auth = useAuth();
  const router = useRouter();
  const { googleMapsIsLoaded } = useContext(GoogleMapsContext);

  // NEW provider API
  const { selectedDate } = useContext(DateContext);

  // Canonical local start-of-day ms
  const dayStart = new Date(selectedDate);
  dayStart.setHours(0, 0, 0, 0);
  const dayStartMs = dayStart.getTime();

  // Redirect if unverified
  useEffect(() => {
    console.log("here in dashboard useffect.");
    const fetchPendingAndUpdateUserAndProduction = async () => {
      if (!auth.user?.uid) return;
      try {
        // check pending signup in Firestore
        const pending = await getPendingSignup(auth.user?.uid);

        console.log("Pending from Firestore:", pending);

        const productionRef = await createProduction(auth.user?.uid, pending.productionData);

        await auth.updateProfile({
          productionId: productionRef.id,
          productionName: pending.productionData.productionName,
          businessName: pending.productionData.businessName,
        });

        // preload one production location on initial sign up
        await createInitialLocationFromSignUpAddress(productionRef, pending.productionData, selectedDate);

        await deletePendingSignup(auth.user?.uid);

        console.log("picked up from where user sign up left off.. user updated and pending signup deleted.");
      } catch (error) {
        console.log("Error with pending user sign up data.");
      }
    };

    if (auth.user?.uid && !auth.rawUser?.emailVerified) {
      router.replace("/auth/verify");
      return null;
    }
    if (auth.user?.uid && auth.rawUser?.emailVerified && auth.user?.userType !== "production") {
      router.replace("/enter-show-info");
      return null;
    }
    // if we get to the dashboard and we're a admin created production, but browser was closed before verification,
    // logged back in after verification so we never got the pending signup data, handle that.
    if (auth?.user?.uid && auth.rawUser?.emailVerified && auth.user?.userType === "production" && !auth.user.productionId) {
      console.log("fetching pending sign up data.. ");
      fetchPendingAndUpdateUserAndProduction();
    }
  }, [auth.user?.uid, auth.rawUser?.emailVerified, router, dayStartMs]); // include dayStartMs for correctness

  const {
    data: productions,
    status: productionsStatus,
    error: productionsError,
  } = useProductionsByOwner(auth?.user?.uid);

  const productionsAreEmpty = !productions || productions.length === 0;

  return googleMapsIsLoaded ? (
    <>
      <Meta title="showNAV | Locations Dashboard" />

      {productionsError && (
        <Box mb={3}>
          <Alert severity="error">{productionsError.message}</Alert>
        </Box>
      )}

      {(productionsStatus === "loading" || productionsAreEmpty) && (
        <Box py={5} px={3} align="center">
          {productionsStatus === "loading" && <CircularProgress size={32} />}
          {productionsStatus !== "loading" && productionsAreEmpty && <>Error retrieving production details.</>}
        </Box>
      )}

      {productionsStatus !== "loading" && productions && productions.length > 0 && (
        <CategoryProvider>
          <SearchProvider>
            {auth?.user?.stripeSubscriptionStatus &&
              !["active", "trialing"].includes(auth?.user?.stripeSubscriptionStatus) && (
                <Alert style={{ justifyContent: "center" }} severity="error">
                  Your subscription is inactive. To access showNAV’s full locations dashboard, please visit the billing section to manage your subscription.
                </Alert>
              )}

            <DashboardSection
              bgColor="default"
              size="medium"
              bgImage=""
              bgImageOpacity={1}
              title={productions[0]?.productionName}
              subtitle=""
              company={productions[0]?.businessName}
              productionId={productions[0]?.id}
            />
          </SearchProvider>
        </CategoryProvider>
      )}
    </>
  ) : (
    <></>
  );
}

export default requireAuth(DashboardPage);
